import { compose } from 'redux';
import withToggleFollow from '../../containers/apollo/withToggleFollow';
import withAnalytics from '../../containers/redux/withAnalytics';
import FollowButton from './FollowButton';

const ComposedFollowButton = compose(
  withAnalytics,
  withToggleFollow
)(FollowButton);

ComposedFollowButton.displayName = FollowButton.displayName;

export default ComposedFollowButton;
